import { combineReducers } from "redux";
import { Action } from "../actions/types";
import { accountReducer } from "./accountHolder";
import authUserReducer from "./authUserReducer";
import branchReducer from "./branchReducer";
import dropdownReducer from "./dropdownReducer";
import { transactionBalanceReducer } from "./transactionBalance";
import { transactionReducer } from "./transactionReducer";
import userReducer from "./userReducer";
import studentFeeReportReducer from "./studentReport";
import StudentFeeDetailsReducer from "./studentFeesDetails";

// Combine reducers
const combinedReducers = combineReducers({
    authUser: authUserReducer,
    user: userReducer,
    branch: branchReducer,
    dropDown: dropdownReducer,
    transactionBalance: transactionBalanceReducer,
    transaction: transactionReducer,
    account: accountReducer,
    studentReport: studentFeeReportReducer,
    studentFeesReducer:StudentFeeDetailsReducer,
});

// Reducer function
const reducers = (state: StoreState | undefined, action: Action) => {
    return combinedReducers(state, action);
};

// Types
export type StoreState = ReturnType<typeof combinedReducers>;
export type GetState = () => StoreState;

export default reducers;
